import { useState } from 'react';
import { DateScreenProps } from '@packages/shared/core/quiz/entities';
import Header from '@packages/shared/core/common/components/layout/Header';
import ButtonBack from '@packages/shared/core/common/components/common/ButtonBack';
import { createDate } from '@packages/shared/core/common/utils/date';
import { DEFAULT_BIRTH_DATE, DEFAULT_BIRTH_DATE_OBJECT } from '@packages/shared/core/common/constants';
import DateSelect from '@packages/shared/core/common/components/common/DateSelect';
import Button from '@packages/shared/core/common/components/common/Button';
import SplitProgressBar from '@packages/shared/simple-registration/components/SplitProgressBar';
import { DateObject } from '@packages/shared/core/common/entities/Date';
import { DataTestId } from '@packages/shared/core/common/constants/dataTestId';
import ProgressBar from '../../ProgressBar';
import Banner from '../../Banner';
import styles from './DateScreen.module.scss';

const DateScreen = ({
  content,
  onBack,
  onSubmit,
  onChange = () => {},
  index: activeStep,
  totalSteps,
  progressBarProps = {
    progressBarName: 'profile',
    progressBarStyle: 'solid',
    totalPersonalitySteps: 4,
    totalProfileSteps: 12,
    totalPreferencesSteps: 9,
  },
}: DateScreenProps) => {
  const [date, setDate] = useState<DateObject>(DEFAULT_BIRTH_DATE_OBJECT);

  const handleDateChange = (newDate: DateObject) => {
    setDate(newDate);
    const dateOfBirth = createDate(`${newDate.month} ${newDate.day} ${newDate.year}`, 'MMM D YYYY').format(
      'YYYY-MM-DD',
    );

    onChange(dateOfBirth === 'Invalid Date' ? DEFAULT_BIRTH_DATE : dateOfBirth);
  };

  const { progressBarName, progressBarStyle, totalPersonalitySteps, totalPreferencesSteps, totalProfileSteps } =
    progressBarProps;

  const handleClick = () => {
    const dateOfBirth = createDate(`${date.month} ${date.day} ${date.year}`, 'MMM D YYYY').format('YYYY-MM-DD');

    return onSubmit(dateOfBirth === 'Invalid Date' ? DEFAULT_BIRTH_DATE : dateOfBirth);
  };

  return (
    <>
      <div className={styles.background} />

      <Banner />

      <Header className={styles.header} menuClassName={styles.menu}>
        <ButtonBack className={styles.buttonBack} secondary onClick={onBack} />
      </Header>

      <div className={styles.container}>
        {progressBarStyle === 'solid' ? (
          <ProgressBar
            className={styles.progressBar}
            title={content.progressTitle}
            steps={totalSteps}
            activeStep={activeStep}
          />
        ) : (
          <SplitProgressBar
            currentStep={activeStep}
            currentName={progressBarName}
            totalPersonalitySteps={totalPersonalitySteps}
            totalPreferencesSteps={totalPreferencesSteps}
            totalProfileSteps={totalProfileSteps}
            totalSteps={totalSteps}
          />
        )}

        <h2 className={styles.title}>{content.title}</h2>

        <h3 className={styles.subtitle}>{content.subtitle}</h3>

        <div className={styles.content}>
          <div className={styles.blockFields}>
            <DateSelect minimumAge={18} onChange={handleDateChange} />
          </div>

          {content.disclaimer && <p className={styles.disclaimer}>{content.disclaimer}</p>}

          <Button
            wrapperClassName={styles.buttonWrapper}
            className={styles.button}
            onClick={handleClick}
            data-testid={DataTestId.SUBMIT_BUTTON}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
};

export default DateScreen;
